import type { ReactNode } from 'react';

import { LiveEventsFeedLoading } from '@/components/live/feed/live-events-feed-boundaries';
import { CategoryActions } from '@/components/shared/category-actions';
import { IconActionSkeleton } from '@/components/shared/listing-discovery-actions-skeleton';
import { Skeleton } from '@/components/ui/app-skeleton';

export function LiveEventsPageLoading(): ReactNode {
  return (
    <div className="flex w-full min-w-0 flex-col gap-4 md:gap-6" aria-busy="true">
      <CategoryActions loading>
        <Skeleton aria-hidden className="h-9 w-36 rounded-control" />
      </CategoryActions>
      <Skeleton className="hidden h-125 w-full rounded-card md:block" />
      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between gap-3">
          <Skeleton className="h-7 w-36 rounded-item" />
          <div className="flex shrink-0 items-center gap-1">
            <IconActionSkeleton />
            <IconActionSkeleton />
          </div>
        </div>
        <div className="flex gap-2 overflow-hidden">
          <Skeleton className="h-9 w-20 shrink-0 rounded-pill" />
          <Skeleton className="h-9 w-20 shrink-0 rounded-pill" />
          <Skeleton className="h-9 w-28 shrink-0 rounded-pill" />
          <Skeleton className="h-9 w-28 shrink-0 rounded-pill" />
          <Skeleton className="ml-auto size-8 shrink-0 rounded-control lg:hidden" />
        </div>
      </div>
      <LiveEventsFeedLoading />
    </div>
  );
}
